<template>
  <div>
    <!-- <el-container style=""> -->
    <el-main style="padding: 20px 32px 0; background: #fff">
      <div>
        <el-form
          :inline="true"
          :label-position="labelPosition"
          v-for="(recruit, index) in recruitmentInfo"
          :key="index"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="岗位名称">
                <div>{{ recruit.title }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item label="薪资范围">
                <div>
                  {{ recruit.min_salary }}&nbsp;-&nbsp;{{
                    recruit.max_salary
                  }}&nbsp;/月
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="职位描述" style="width: 100%">
                <div>{{ recruit.content }}</div>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="24"> -->
            <!-- </el-col> -->
          </el-row>
          <div class="enterprise-line" v-if="recruitmentInfo.length > 1"></div>
        </el-form>
      </div>
      <el-dialog
        title="您确定拒绝此校友企业的申请吗？"
        :rules="dataRules"
        :visible.sync="dialogVisible"
        width="40%"
        style="text-align: left"
        center
      >
        <div>修改建议 (200字以内)</div>
        <el-input
          type="textarea"
          :rows="5"
          maxlength="200"
          show-word-limit
          v-model="content"
          resize="none"
          style="width: 95%; height: 100px; margin-top: 8px"
          @change="checkInput"
        />
        <span slot="footer" class="dialog-footer">
          <el-button @click="cannel">取 消</el-button>
          <el-button type="primary" @click="sureChoice">确 定</el-button>
        </span>
      </el-dialog>
      <enterprise-foot-2 v-on:acceptName="acceptName"></enterprise-foot-2>
    </el-main>
    <!-- </el-container> -->
  </div>
</template>

<script>
import EnterpriseFoot2 from "@/components/enterprise/enterpriseFoot2";
export default {
  components: {
    EnterpriseFoot2,
  },
  data() {
    return {
      labelPosition: "top",
      recruitmentInfo: [],
      passIf: "",
      dialogVisible: false,
      content: "",
      dataRules: {
        RejectNote: [
          { max: 200, message: "不能超过200个字符", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getshopRecruit();
  },
  methods: {
    // 获取招聘岗位信息
    getshopRecruit() {
      var id = localStorage.getItem("id");
      console.log(id);
      this.$api
        .waitReviewShopInfo({
          token: localStorage.getItem("token"),
          shop_log_id: id,
        })
        .then(({ data }) => {
          this.recruitmentInfo = data.Data.shop_recruit;
          console.log(this.recruitmentInfo);
        })
        .catch(({ error }) => {
          setTimeout(() => {
            this.$router.back(-1);
          }, 500);
        });
    },
    //通过审核
    getExecReviewShopInfo() {
      var id = localStorage.getItem("id");
      this.$api
        .execReviewShopInfo({
          token: localStorage.getItem("token"),
          shop_log_id: id,
          is_pass: this.passIf,
        })
        .then(({ data }) => {
          this.$message({
            message: "已通过该企业申请",
            type: "success",
          });
          console.log(data);
          setTimeout(() => {
            this.$router.back(-1);
            // this.$router.push({
            //   path: "/wxapp/enterprise",
            //   query: { activeName: "2" },
            //   params: { refresh: true },
            // });
          }, 1000);
        })
        .catch(({ error }) => {});
    },
    //接收子组件传过来的数据并处理
    acceptName(acceptName) {
      // debugger;
      this.passIf = acceptName;
      if (this.passIf == "N") {
        this.dialogVisible = true;
      } else {
        this.getExecReviewShopInfo();
      }
      console.log(this.passIf);
    },
    checkInput(val) {
      //当前字符串的字节数
      var strlen = 0;
      //用来做字符串截取的下标
      var index = 0;
      //限制的最大输入长度
      var max = 200;
      for (var i = 0; i < val.length; i++) {
        if (strlen > max) {
          //输入长度超标的提示
          this.msgError("超过200字");
          break;
        }
        index = i + 1;
        //判别是中文字符还是英文字符的方法
        if (val.charCodeAt(i) < 27 || val.charCodeAt(i) > 126) {
          //中文和中文字符
          strlen += 2;
        } else {
          strlen++;
        }
      }
      // 自动截掉多余的字符。保留之前的限制内的字符长度
      if (strlen > max) {
        this.content = val.substr(0, index - 1);
      } else {
        this.content = val.substr(0, index);
      }
    },

    //点击弹窗确定
    sureChoice() {
      this.dialogVisible = false;
      var id = localStorage.getItem("id");
      this.$api
        .execReviewShopInfo({
          token: localStorage.getItem("token"),
          shop_log_id: id,
          is_pass: this.passIf,
          remark: this.content,
        })
        .then(({ data }) => {
          this.$message({
            message: "已拒绝该企业申请",
            type: "success",
          });
          setTimeout(() => {
            this.$router.back(-1);
            // this.$router.push({
            //   path: "/wxapp/enterprise",
            //   query: { activeName: "2", refresh: true },
            // });
          }, 1000);
        })
        .catch(({ error }) => {});
    },
    cannel() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.enterprise-line {
  margin-left: 0;
  margin-bottom: 20px;
  width: 100%;
  height: 1px;
  background: #e9e9e9;
}
// .foot{
//   width: 85%;
//   height: 50px;
//   background: #e9e9e9;
//   position: fixed;
//   left: 13.6vw;
//   bottom: 0;
// }
</style>



// WEBPACK FOOTER //
// src/components/enterprise/enterpriseWaitPosition.vue